
















import { Component, Vue, Prop, Ref} from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import mavonEditor from 'mavon-editor';
import 'mavon-editor/dist/css/index.css';
import { upload } from '@/utils/attachment';

@Component({
  components: {
    mavonEditor: mavonEditor.mavonEditor,
  },
})
export default class MarkedEditor extends Vue {
  @Ref() private readonly editor!: any;
  @Prop({required: true, default: () => ''}) private content!: string;
  get language() {
    if (AppModule.language === 'zh') {
      return 'zh-CN';
    } else {
      return 'en';
    }
  }
  private externalLink = {
    markdown_css() {
      return 'markdown/github-markdown.min.css';
    },
    hljs_js() {
      // 这是你的hljs文件路径
      return 'markdown/highlight.min.js';
    },
    katex_css() {
      // 这是你的katex配色方案路径路径
      return 'markdown/katex.min.css';
    },
    katex_js() {
      // 这是你的katex.js路径
      return 'markdown/katex.min.js';
    },
  };
  private toolbars = {
    bold: true, // 粗体
    italic: true, // 斜体
    header: true, // 标题
    underline: true, // 下划线
    strikethrough: true, // 中划线
    mark: true, // 标记
    superscript: true, // 上角标
    subscript: true, // 下角标
    quote: true, // 引用
    ol: true, // 有序列表
    ul: true, // 无序列表
    link: true, // 链接
    imagelink: true, // 图片链接
    code: true, // code
    table: true, // 表格
    fullscreen: true, // 全屏编辑
    readmodel: true, // 沉浸式阅读
    htmlcode: false, // 展示html源码
    help: true, // 帮助
    /* 1.3.5 */
    undo: true, // 上一步
    redo: true, // 下一步
    trash: true, // 清空
    save: false, // 保存（触发events中的save事件）
    /* 1.4.2 */
    navigation: false, // 导航目录
    /* 2.1.8 */
    alignleft: true, // 左对齐
    aligncenter: true, // 居中
    alignright: true, // 右对齐
    /* 2.2.1 */
    subfield: true, // 单双栏模式
    preview: true, // 预览
  };
  private uploadImg(filename: string, imgfile: File) {
    if (!imgfile) {
      return;
    }
    const formData = new FormData();
    formData.append('file', imgfile);
    upload(formData).then((res) => {
      this.editor.$img2Url(filename, res.path);
    }).catch((err) => {
      this.$message.error(err.message);
    });
  }
  private changeValue(value: string, result: string) {
    this.$emit('change', value);
  }
}
